import { session } from './utilities/session';
import React, { useEffect, useState, createContext, Suspense, useMemo } from 'react';

//import Weather from './components/weather/Weather';
import 'leaflet/dist/leaflet.css';
import 'leaflet-draw/dist/leaflet.draw.css';
import './App.less';
import { ConfigProvider, Layout, Spin } from 'antd'

//Views
import AuthView from './views/Auth/Auth';
import VerifyEmailView from './views/Auth/VerifyEmail';
import CropClassificationView from './views/CropClassification';
import TeamView from './views/Team';
import BaseView from './views/Base';

// Utilities
import { ProtectedRoute } from "./utilities/protected_route";

import AuthContext from './contexts/AuthContext';

import UserService from './services/User';

import { BrowserRouter, Navigate, Route, Routes, useLocation, useNavigate } from 'react-router-dom';

//Styles
import "./App.css"
import './styles/index.css'
import antdTheme from './theme/antdTheme';
import applyTheme from './theme/applyTheme';

import { message  } from 'antd';

import { lazy } from 'react';
import QueryProvider from './providers/QueryProvider';
import { CCProvider } from './contexts/CCContext';

const LazyHomeView = lazy(() => import('./views/Home'));
const LazyNDVIView = lazy(() => import('./views/CropGrowth'));
const LazyWeatherView = lazy(() => import('./views/Weather'));
const LazyFieldNDVIView = lazy(() => import('./views/FieldNDVI'));
const LazyFieldsControlProvisionsView = lazy(() => import('./views/FieldControlProvisions/FieldsControlProvisions'));
const LazyFieldsView = lazy(() => import('./views/Fields'));
const LazyAddEditProvisionView = lazy(() => import('./views/FieldControlProvisions/AddEditProvision'));
const LazyTeamView = lazy(() => import('./views/Team'));
const LazyFarmersView = lazy(() => import('./views/Farmers'));
const LazySeasonsView = lazy(() => import('./views/Seasons'));
const LazySeasonProfileView = lazy(() => import('./views/SeasonProfile'));
const LazyFarmerView = lazy(() => import('./views/FarmerProfile'));
const LazyTeamMemberProfile = lazy(() => import('./views/TeamMemberProfile'));
const LazyAuthView = lazy(() => import('./views/Auth/Auth'));
const LazyInvestigateView = lazy(() => import('./views/Investigate'));
const LazyTasksView = lazy(() => import('./views/Tasks'));

//FIXME - Repetition; check LeftSidebar.js, IndexTimeline.js, AddEditProvisions.js, agcc-map.js
const Loading = () => {
  return (
    <Layout className='view-loading-overlay'>
      <div className='view-loading-overlay-content'>
        <Spin />
      </div>
    </Layout>
  );
}

// GLobal Context
export const GlobalContext = createContext({});

function QueryParams(props) {
  const setQueryParams = props.setQueryParams;
  const query_params = props.queryParams;

  // A custom hook that builds on useLocation to parse
  // the query string for you.
  const useQuery = () => {
    const { search } = useLocation();

    return React.useMemo(() => new URLSearchParams(search), [search]);
  }
 
  const query = useQuery();
  useEffect(()=>{
    if (query !== query_params)
		  setQueryParams(query);

	}, [ query, query_params, setQueryParams])
  
  return (<></>);
}

const MainLayout = () => {
  return (
      <Routes>
        {/* Login View */}
        <Route path="/login" element={<AuthView type="login"/>} />

        {/* Register View */}
        <Route path="/register" element={<AuthView type="register" />} />

        {/* Logout */}
        <Route path="/logout" element={<AuthView type="logout" />} />

        {/* Verify Email */}
        <Route path="/verify-email" element={<VerifyEmailView />} />

        {/** Protected Base View */}
        <Route path="/" element={<ProtectedRoute><CCProvider><BaseView /></CCProvider></ProtectedRoute>}>
          {/* Home View  */}
          <Route index element={<Suspense fallback={<Loading />}><LazyHomeView /></Suspense>} />
          <Route path="home" element={<Suspense fallback={<Loading />}><LazyHomeView /></Suspense>} />
          <Route path="home/fields/:id" element={ <Suspense fallback={<Loading />}><LazyHomeView /></Suspense>} />

          <Route path="seasons" element={<Suspense fallback={<Loading />}><LazySeasonsView /></Suspense>}/>
          <Route path="seasons/season/:id" element={ <Suspense fallback={<Loading />}><LazySeasonProfileView /></Suspense>} />

          {/* Weather */}
          <Route path="weather" element={ <Suspense fallback={<Loading />}><LazyWeatherView /></Suspense> }/>
          <Route path="weather/fields/:id" element={ <Suspense fallback={<Loading />}><LazyWeatherView /></Suspense> } />

          {/* NDVI */}
          <Route path="crop-growth" element={<Suspense fallback={<Loading />}><LazyNDVIView /></Suspense>} />

          {/* Fields */}
          <Route path="fields" element={<Suspense fallback={<Loading />}><LazyFieldsView /></Suspense>} />

          {/* NDVI */}
          <Route path="ndvi" element={ <Suspense fallback={<Loading />}><LazyNDVIView /></Suspense>} />
          <Route path="ndvi/fields/:id" element={<Suspense fallback={<Loading />}> <LazyFieldNDVIView /></Suspense> } />

          {/* Field Control Provisions */}
          <Route path="provisions" element={ <Suspense fallback={<Loading />}><LazyFieldsControlProvisionsView /></Suspense>} />
          <Route path="provisions/fields/:id" element={<Suspense fallback={<Loading />}> <LazyFieldsControlProvisionsView /></Suspense> } />
          <Route path="provisions/new" element={<Suspense fallback={<Loading />}> <LazyAddEditProvisionView /></Suspense> } />
          <Route path="provisions/edit/:id" element={<Suspense fallback={<Loading />}> <LazyAddEditProvisionView /></Suspense> } />

          {/* Field Control Provisions */}
          <Route path="farmers" element={ <Suspense fallback={<Loading />}><LazyFarmersView /></Suspense>} />
          <Route path="farmers/farmer/:id" element={<Suspense fallback={<Loading />}> <LazyFarmerView /></Suspense> } />

          {/* Team */}
          <Route path="team" element={<Suspense fallback={<Loading />}><LazyTeamView /></Suspense>} />
          <Route path="team/member/:id" element={<Suspense fallback={<Loading />}><LazyTeamMemberProfile /></Suspense>} />
        
          {/* Tasks */}
          <Route path="tasks" element={<Suspense fallback={<Loading />}><LazyTasksView /></Suspense>} />
        
          {/* Investigate */}
          <Route path="investigate" element={<Suspense fallback={<Loading />}><LazyInvestigateView /></Suspense>} />

          {/* Crop Classification */}
          <Route path="cc" element={<CropClassificationView />} >
            <Route path="yield/:crop" element={ <Suspense fallback={<Loading />}><CropClassificationView /></Suspense> } />
          </Route>
        </Route>
        
        {/* Catch-all redirect to login */}
        <Route path="*" element={<Navigate to="/login" replace />} />

      
      </Routes>
  )
}

const App = () => {
  
  // State to track token processing - blocks app until complete
  const [isProcessingUrlToken, setIsProcessingUrlToken] = useState(true);
  const [authReady, setAuthReady] = useState(false);

  // Extract and verify token from URL - blocks app rendering until complete
  useEffect(() => {
    const handleUrlToken = async () => {
      const pathName = window.location.pathname || '';
      const isVerifyEmailPath = pathName.endsWith('/verify-email');
      const urlParams = new URLSearchParams(window.location.search);
      const token = urlParams.get('token');
      
      // Keep verification token in the URL for /verify-email route; App token bootstrap is for login handoff flows.
      if (token && !isVerifyEmailPath) {
        session.install({ access_token: token });
        const newUrl = window.location.pathname;
        window.history.replaceState({}, document.title, newUrl);
      }
      
      setIsProcessingUrlToken(false);
      // Small delay to ensure all token operations are complete
      setTimeout(() => setAuthReady(true), 100);
    };

    handleUrlToken().catch(() => { setIsProcessingUrlToken(false); setAuthReady(true); });
  }, []);

  useEffect(() => {
    applyTheme();
  }, []);
  
  // Map layer controls - manages which base/overlay layers are visible on maps
  // Used across all map views to switch between satellite, terrain, and other base layers
  const [selected_map_layer, setSelectedMapLayer] = useState({});
  
  // Vegetation index overlays (NDVI, EVI, etc.) - controls satellite data visualization
  // Displays crop health and growth data as colored overlays on field boundaries
  const [selected_index_overlay, setSelectedIndexOverlay] = useState(null);
  
  // Currently selected vegetation index from sidebar menu - syncs UI selection
  // Ensures the selected index in UI matches what's displayed on the map
  const [selected_index, setSelectedIndex] = useState(null);
  
  // URL query parameters - enables deep linking and state persistence across routes
  // Allows users to bookmark specific field views and share URLs with filters applied
  const [query_params, setQueryParams] = useState();
  
  // Selected field/farm asset - tracks user's current focus for data filtering
  // Filters weather, NDVI, and other data to show only relevant information for chosen field
  const [selected_user_asset, setSelectedUserAsset] = useState();
  
  // Field drawing mode toggle - enables/disables polygon drawing tools on maps
  // Activates drawing controls when users need to create new field boundaries
  const [globalFieldDrawUIEnabled, setGlobalFieldDrawUIEnabled] = useState(false);
  
  // Crop classification view toggle - switches between normal and CC analysis modes
  // Changes map interface to show crop type analysis and classification tools
  const [globalCCViewEnabled, setGlobalCCViewEnabled] = useState(false);
  
  // Selected geographic region - coordinates map focus and data queries
  // Defines the area of interest for loading relevant fields and satellite data
  const [globalSelectedRegion, setGlobalSelectedRegion] = useState({});
  
  // Map center coordinates - synchronizes map position across different views
  // Maintains consistent map location when navigating between weather, NDVI, and field views
  const [global_map_center, setGlobalMapCenter] = useState(false);
  
  // Newly drawn field geometry - stores user-created field boundaries before saving
  // Holds polygon coordinates while user confirms field details before database submission
  const [drawnField, setDrawnField] = useState({});
  
  // Investigation area polygon - defines analysis boundaries for investigate feature
  // Allows users to draw custom areas for detailed crop analysis and data extraction
  const [investigatePolygon, setInvestigatePolygon] = useState(null);
  
  // True Color Image layer reference - manages satellite imagery display
  // Used to show satellite imagery for specific AOI when adding fields or investigating them
  const [tciLayer, setTciLayer] = useState(null);
  
  // TCI layers for field editing and drawing modes - manages multiple TCI overlays
  // Stores array of TCI layers with their geometries and dates for field editing
  const [tciLayers, setTciLayers] = useState([]);
  const [showTciLayers, setShowTciLayers] = useState(true);
  
  // Active growing seasons filter - controls which seasons' data is displayed
  // Filters historical data to show only selected years/seasons across all views
  const [activeSeasons, setActiveSeasons] = useState(new Set());
  
  // Field editing mode - enables modification of existing field boundaries
  // Activates edit tools when users need to update or correct field polygon shapes
  const [fieldEditMode, setFieldEditMode] = useState(false);
  
  // Backup of field data before editing - enables cancel/revert functionality
  // Stores original field geometry to restore if user cancels editing changes
  const [originalFieldData, setOriginalFieldData] = useState(null);


  // Season filtering options - controls data display by year, crop type, and status
  // Used in seasons view to filter which growing seasons are shown in tables and charts
  const [seasonFilters, setSeasonFilters] = useState(() => ({ year: new Date().getFullYear(), crop: null, status: 'all' }));
  
  // Ant Design message system - provides app-wide notifications and alerts
  // Displays success/error messages for user actions like saving fields or data loading
  const [messageAPI, contextHolder] = message.useMessage();

  const [proceed, setProceed] = useState(false);

  
  // Init Local Storage Items
  if(!localStorage.getItem("FieldsSatData")){ // satellite data for the fields, ndvi, constrast_ndvi, sentinel2 etc.
    localStorage.setItem("FieldsSatData", JSON.stringify({}));
  }

  if(!localStorage.getItem("Fields")) { // all fields data coming from /field
    localStorage.setItem("Fields", JSON.stringify({}));
  }

  if(!localStorage.getItem("fieldsdata")) { // all fields data coming from /data/field
    localStorage.setItem("fieldsdata", JSON.stringify({data: [], last_update: "", should_update: ""}));
  }

  if(!localStorage.getItem("Segmentations")) { // 
    localStorage.setItem("Segmentations", JSON.stringify([]));
  }

  if(!localStorage.getItem("token")) { // 
    localStorage.setItem("token", null);
  }
  


  if(!localStorage.getItem("InvestigatePolygons")) { // drawn polygons for investigate feature
    localStorage.setItem("InvestigatePolygons", JSON.stringify([]));
  }

  return (
    <ConfigProvider theme={antdTheme}>
      <QueryProvider>
        <GlobalContext.Provider 
        value={{ 
          selected_map_layer, 
          setSelectedMapLayer, 
          query_params, 
          setQueryParams,
          selected_user_asset,
          setSelectedUserAsset,
          messageAPI, 
          contextHolder,
          selected_index_overlay,
          setSelectedIndexOverlay,
          selected_index,
          setSelectedIndex,
          globalFieldDrawUIEnabled,
          setGlobalFieldDrawUIEnabled,
          globalCCViewEnabled, 
          setGlobalCCViewEnabled,
          globalSelectedRegion,
          setGlobalSelectedRegion,
          drawnField,
          setDrawnField,
          investigatePolygon,
          setInvestigatePolygon,
          tciLayer,
          setTciLayer,
          global_map_center,
          setGlobalMapCenter,
          activeSeasons,
          setActiveSeasons,
          seasonFilters,
          setSeasonFilters,
          fieldEditMode,
          setFieldEditMode,
          originalFieldData,
          setOriginalFieldData,
          tciLayers,
          setTciLayers,
          showTciLayers,
          setShowTciLayers,
        }}>
        <div className="App">
          {isProcessingUrlToken || !authReady ? (
            <Layout className='view-loading-overlay'>
              <div className='view-loading-overlay-content'>
                <Spin />
                <div style={{marginTop: 16}}>Processing authentication...</div>
              </div>
            </Layout>
          ) : (
            <BrowserRouter basename="/app">
              <QueryParams queryParams={query_params} setQueryParams={setQueryParams}/>
              <MainLayout >  
              </MainLayout>
            </BrowserRouter>
          )}
        </div>
        </GlobalContext.Provider>
      </QueryProvider>
    </ConfigProvider>
  );
};

export default App
